export default __webpack_public_path__ + "static/media/detailsCarRejected.28d4a873.png";